export default (props, vars) => vars?.['defaultbox145']?.['index'] > 0;
